export default __webpack_public_path__ + "assets/images/listen-icon2-380fd64d.svg";